(function() {
    // Helper functions
    function setCookie(name, value, days) {
      var expires = '';
      if (typeof days === 'number') {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = '; expires=' + date.toUTCString();
      }
      document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/';
    }

    function getCookie(name) {
      var match = document.cookie.match(new RegExp('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)'));
      return match ? decodeURIComponent(match.pop()) : null;
    }

    function showBanner() {
      var banner = document.getElementById('RolexPrivacyBanner');
      if (banner) banner.style.display = '';
    }

    function hideBanner() {
      var banner = document.getElementById('RolexPrivacyBanner');
      if (banner) banner.style.display = 'none';
    }

    // Initialize consent cookies if not present
    if (getCookie('rlx-consent') === null) {
      setCookie('rlx-consent', 'false', 180);
    } 
    if (getCookie('rlx-marketing') === null) {
      setCookie('rlx-marketing', 'false', 180);
    }

    // privacyBanner: if not set, show the banner and set it to 'false' so the user won't see it again until cookies cleared
    if (getCookie('privacyBanner') === null) {
      // show the banner once
      document.addEventListener('DOMContentLoaded', function() {
        showBanner();
      });
      // record that we've shown it (per requirements set to 'false')
      setCookie('privacyBanner', 'false', 180);
    }

    // Wire buttons and behavior after DOM ready
    document.addEventListener('DOMContentLoaded', function() {
      var chkPerformance = document.getElementById('rlx-cookie-performance');
      var chkMarketing = document.getElementById('rlx-cookie-marketing');

      var btnAll = document.getElementById('RolexConsentAcceptAll');
      var btnEssential = document.getElementById('RolexConsentAcceptEssential');
      var btnSelection = document.getElementById('RolexConsentAcceptSelection');
      var btnClose = document.getElementById('RolexConsentClose');

      var bodyElement = document.body;
      var isRolex = bodyElement.classList.contains('rlx');

      // Sync checkbox states with existing cookie values
      if (chkPerformance && getCookie('rlx-consent') === 'true') {
        chkPerformance.checked = true;
      }
      if (chkMarketing && getCookie('rlx-marketing') === 'true') {
        chkMarketing.checked = true;
      }

      function acceptAll() {
        // Accept everything
        setCookie('rlx-consent', 'true', 180);
        setCookie('rlx-marketing', 'true', 180);
        if(isRolex){
          if (typeof _satellite !== 'undefined') {
            _satellite.setVar("Analyticsconsent", "true");
          }
        }
        hideBanner();
      }

      function acceptOnlyEssential() {
        // Essential only: performance & marketing false
        setCookie('rlx-consent', 'false', 180);
        setCookie('rlx-marketing', 'false', 180);
        if (chkPerformance) {
          chkPerformance.checked = false;
        }
        if (chkMarketing) {
          chkMarketing.checked = false;
        }
        if(isRolex){
          if (typeof _satellite !== 'undefined') {
            _satellite.setVar("Analyticsconsent", "false");
          }
        }
        hideBanner();
      }

      function acceptSelection() {
        // Performance -> rlx-consent, Marketing -> rlx-marketing
        if (chkPerformance && chkPerformance.checked) {
          setCookie('rlx-consent', 'true', 180);
        } else {
          setCookie('rlx-consent', 'false', 180);
        }

        if (chkMarketing && chkMarketing.checked) {
          setCookie('rlx-marketing', 'true', 180);
        } else {
          setCookie('rlx-marketing', 'false', 180);
        }

        hideBanner();
      }

      if (btnAll) btnAll.addEventListener('click', acceptAll);
      if (btnEssential) btnEssential.addEventListener('click', acceptOnlyEssential);
      if (btnSelection) btnSelection.addEventListener('click', acceptSelection);
      if (btnClose) btnClose.addEventListener('click', hideBanner);

      // Listen for external controls to open the cookie banner (e.g. a "Manage cookies" button elsewhere)
      var updateConsentBtn = document.getElementById('updateCookieConsent');
      if (updateConsentBtn) {
        updateConsentBtn.addEventListener('click', function(e){
          e.preventDefault();
          showBanner();
        });
      }

      // Also add delegated listener so dynamically-inserted controls with that id will still work
      document.addEventListener('click', function(e) {
        var target = e.target;
        if (!target) return;
        if (target.id === 'updateCookieConsent' || (target.closest && target.closest('#updateCookieConsent'))) {
          e.preventDefault();
          showBanner();
        }
      });
    });
  })();